var _metadata, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBebasNeueWebfont(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "bebas_neueregular",
    horizAdvX: 396
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 1000,
    ascent: 750,
    descent: -250
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 155
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 1000
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 1000
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\r",
    horizAdvX: 1000
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 155
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 155
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 155
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 190,
    d: "M40 408v292h110v-292l-14 -253h-82zM42 0v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 325,
    d: "M40 700h106l-16 -206h-75zM179 700h106l-16 -206h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 410,
    d: "M15 200l8 78h49l19 183h-50l8 78h50l17 161h90l-17 -161h65l17 161h90l-17 -161h51l-8 -78h-51l-19 -183h51l-8 -78h-51l-21 -200h-90l21 200h-65l-21 -200h-90l21 200h-49zM162 278h65l19 183h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    d: "M34 178v48h104v-55q0 -68 57 -68t57 68q0 39 -20 70.5t-74 73.5q-67 53 -94 99.5t-27 107.5q0 145 116 171v52h90v-52q118 -24 118 -171v-22h-104v29q0 69 -55 69t-55 -69q0 -38 20 -69.5t74 -74.5q67 -54 94 -100.5t27 -106.5q0 -72 -30.5 -116t-88.5 -56v-51h-90v51 q-119 24 -119 172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 627,
    d: "M34 363v230q0 54 27 83t79 29t79 -29t27 -83v-230q0 -54 -27 -83t-79 -29t-79 29t-27 83zM104 358q0 -44 36 -44t36 44v240q0 44 -36 44t-36 -44v-240zM140 0l276 700h65l-276 -700h-65zM381 107v230q0 54 27 83t79 29t79 -29t27 -83v-230q0 -54 -27 -83t-79 -29t-79 29 t-27 83zM451 102q0 -44 36 -44t36 44v240q0 44 -36 44t-36 -44v-240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 414,
    d: "M41 152v71q0 112 76 146v2q-76 32 -76 143v13q0 173 164 173h126v-100h-124q-56 0 -56 -68v-43q0 -40 16.5 -57t49.5 -17h48v78h110v-78h29v-100h-29v-230q0 -57 12 -85h-112q-8 22 -10 55h-2q-29 -63 -100 -63q-122 0 -122 160zM151 161q0 -69 57 -69q54 0 57 61v162 h-42q-38 0 -55 -20.5t-17 -68.5v-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 180,
    d: "M37 700h106l-16 -206h-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 251,
    d: "M47 153v394q0 83 35.5 118t118.5 35h34v-90h-27q-27 0 -39 -13.5t-12 -49.5v-394q0 -36 12 -49.5t39 -13.5h27v-90h-34q-83 0 -118.5 35t-35.5 118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 251,
    d: "M16 0v90h27q27 0 39 13.5t12 49.5v394q0 36 -12 49.5t-39 13.5h-27v90h34q83 0 118.5 -35t35.5 -118v-394q0 -83 -35.5 -118t-118.5 -35h-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    d: "M2 525l28 85l149 -75l-26 165h90l-26 -165l149 75l28 -85l-164 -28l117 -117l-72 -53l-77 148l-77 -148l-72 53l117 117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    d: "M25 311v78h134v135h78v-135h134v-78h-134v-137h-78v137h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 186,
    d: "M40 0v106h106v-95l-48 -111h-45l29 100h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 270,
    d: "M35 300v100h200v-100h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 186,
    d: "M40 0v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 381,
    d: "M5 0l276 700h95l-276 -700h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    d: "M108 534v78q57 0 81 22t40 66h74v-700h-110v534h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    d: "M40 0v86q0 59 24.5 109t85.5 114q62 65 85 113t23 106q0 45 -14.5 62.5t-42.5 17.5q-57 0 -57 -69v-75h-104v68q0 85 42 130.5t122 45.5t122 -45.5t42 -130.5q0 -71 -30.5 -133.5t-105.5 -143.5q-48 -52 -65.5 -82t-17.5 -58q0 -10 1 -15h208v-100h-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    d: "M34 168v58h104v-65q0 -69 57 -69q28 0 42.5 17.5t14.5 61.5v55q0 48 -17 68.5t-55 20.5h-37v100h43q33 0 49.5 17t16.5 57v39q0 45 -14.5 62.5t-42.5 17.5q-57 0 -57 -69v-45h-104v38q0 85 42 130.5t122 45.5t122 -45.5t42 -130.5v-18q0 -111 -77 -143v-2q77 -34 77 -146 v-55q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    d: "M14 127v100l200 473h120v-473h52v-100h-52v-127h-110v127h-210zM115 227h109v259h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    d: "M35 168v58h104v-65q0 -68 57 -68t57 68v154q0 69 -57 69t-57 -69v-21h-104l20 406h290v-100h-192l-9 -167h2q31 51 95 51q122 0 122 -160v-156q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    d: "M33 168v358q0 182 168 182q80 0 122 -45.5t42 -130.5v-18h-104v25q0 69 -57 69q-31 0 -46 -19t-15 -67v-127h2q29 61 100 61q122 0 122 -160v-128q0 -84 -43 -130t-124 -46t-124 46t-43 130zM143 161q0 -68 57 -68t57 68v126q0 69 -57 69t-57 -69v-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    d: "M33 600v100h330v-96l-162 -604h-110l161 600h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    d: "M26 168v55q0 107 68 145v2q-68 37 -68 140v22q0 84 44.5 130t127.5 46t127.5 -46t44.5 -130v-22q0 -102 -68 -140v-2q68 -38 68 -145v-55q0 -84 -44.5 -130t-127.5 -46t-127.5 46t-44.5 130zM136 171q0 -79 62 -79q61 0 62 79v65q0 79 -62 79t-62 -79v-65zM136 489 q0 -74 62 -74t62 74v39q0 80 -62 80t-62 -80v-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    d: "M29 404v128q0 84 43 130t124 46t124 -46t43 -130v-358q0 -182 -168 -182q-80 0 -122 45.5t-42 130.5v18h104v-25q0 -69 57 -69q31 0 46 19t15 67v127h-2q-29 -61 -100 -61q-122 0 -122 160zM139 413q0 -69 57 -69t57 69v126q0 68 -57 68t-57 -68v-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 186,
    d: "M40 0v106h106v-106h-106zM40 381v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 186,
    d: "M40 0v106h106v-95l-48 -111h-45l29 100h-42zM40 381v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    d: "M30 311v78l326 120v-79l-224 -80l224 -80v-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    d: "M35 230v78h326v-78h-326zM35 392v78h326v-78h-326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    d: "M40 191v79l224 80l-224 80v79l326 -120v-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 360,
    d: "M20 463v69q0 85 41 130.5t121 45.5t121 -45.5t41 -130.5q0 -56 -16.5 -101.5t-57.5 -99.5q-32 -43 -44 -73t-12 -64q0 -22 4 -39h-98q-6 18 -6 43q0 42 12.5 77.5t44.5 80.5q36 51 49.5 91.5t13.5 91.5q0 69 -55 69t-55 -69v-76h-104zM115 0v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 689,
    d: "M24 290q0 94 23.5 175t68 142.5t116 97t161.5 35.5q148 0 213 -80t65 -214q0 -87 -19 -152.5t-50 -100t-62.5 -50.5t-63.5 -16q-81 0 -87 66h-2q-29 -60 -94 -60q-45 0 -69.5 31.5t-24.5 88.5q0 12 2 34l11 101q15 148 120 148q62 0 82 -61h2l9 57h93l-30 -289 q-3 -25 20 -25q39 0 59.5 69.5t20.5 156.5q0 98 -49 154.5t-150 56.5q-132 0 -201.5 -98t-69.5 -272q0 -124 58.5 -192.5t174.5 -68.5q119 0 207 68l-8 -96q-84 -56 -205 -56q-163 0 -242 93.5t-79 256.5zM297 277q0 -49 44 -51q23 -1 37.5 14.5t18.5 48.5l10 95q1 6 1 12 q0 22 -12 33t-32 11q-50 0 -57 -63l-9 -85q-1 -8 -1 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM145 222h106l-52 354h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 406,
    d: "M40 0v700h166q85 0 124 -39.5t39 -121.5v-25q0 -107 -71 -140v-2q82 -32 82 -149v-57q0 -81 -42.5 -123.5t-124.5 -42.5h-173zM150 100h63q29 0 43 15.5t14 53.5v61q0 48 -16.5 66.5t-54.5 18.5h-49v-215zM150 415h43q33 0 49.5 17t16.5 57v39q0 72 -56 72h-53v-185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 386,
    d: "M31 168v364q0 85 42 130.5t122 45.5t122 -45.5t42 -130.5v-68h-104v75q0 69 -57 69t-57 -69v-378q0 -68 57 -68t57 68v100h104v-93q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 408,
    d: "M40 0v700h174q164 0 164 -173v-354q0 -173 -164 -173h-174zM150 100h62q56 0 56 68v364q0 68 -56 68h-62v-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 344,
    d: "M40 0v700h291v-100h-181v-211h142v-100h-142v-289h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 390,
    d: "M31 168v364q0 85 42 130.5t122 45.5t122 -45.5t42 -130.5v-68h-104v75q0 69 -57 69t-57 -69v-378q0 -68 57 -68t57 68v129h-50v100h154v-222q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 427,
    d: "M40 0v700h110v-300h125v300h112v-700h-112v300h-125v-300h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 190,
    d: "M40 0v700h110v-700h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 256,
    d: "M10 0v100q12 -1 38 -1q63 0 63 67v534h110v-526q0 -176 -158 -176q-35 0 -53 2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 414,
    d: "M40 0v700h110v-303h2l142 303h110l-153 -312l153 -388h-113l-107 279l-34 -64v-215h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 339,
    d: "M40 0v700h110v-600h181v-100h-291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 541,
    d: "M39 0v700h153l80 -497h2l74 497h153v-700h-104v502h-2l-74 -502h-104l-80 495h-2v-495h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 427,
    d: "M39 0v700h138l111 -419h2v419h98v-700h-113l-135 507h-2v-507h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 377,
    d: "M40 0v700h162q164 0 164 -173v-91q0 -173 -164 -173h-52v-263h-110zM150 363h52q27 0 40.5 15t13.5 51v105q0 36 -13.5 51t-40.5 15h-52v-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -59 -21 -98q6 -15 31 -15h10v-98h-15q-71 0 -95 48q-36 -13 -77 -13q-81 0 -124 46t-43 130zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 402,
    d: "M40 0v700h166q85 0 124 -39.5t39 -121.5v-55q0 -107 -72 -141v-2q73 -31 73 -148v-108q0 -57 12 -85h-112q-10 30 -10 86v110q0 48 -17 68.5t-55 20.5h-38v-285h-110zM150 385h43q33 0 49.5 17t16.5 57v69q0 72 -56 72h-53v-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 374,
    d: "M23 168v43h104v-50q0 -68 57 -68t57 68q0 39 -20.5 72t-73.5 80q-68 60 -94.5 109t-26.5 110q0 85 41 130.5t121 45.5t121 -45.5t41 -130.5v-22h-104v29q0 69 -55 69t-55 -69q0 -39 20.5 -72t73.5 -80q68 -60 94.5 -109t26.5 -110q0 -85 -42 -130.5t-122 -45.5t-122 45.5 t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 356,
    d: "M8 600v100h340v-100h-115v-600h-110v600h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 402,
    d: "M11 700h111l83 -571h2l83 571h101l-108 -700h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 563,
    d: "M15 700h107l58 -552h2l52 552h106l54 -556h2l56 556h96l-78 -700h-146l-39 373h-2l-39 -373h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 430,
    d: "M15 0l123 360l-115 340h114l82 -258h2l84 258h102l-115 -340l123 -360h-116l-89 277h-2l-90 -277h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    d: "M4 700h115l83 -319h2l83 319h105l-139 -468v-232h-110v232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 370,
    d: "M23 0v98l209 502h-199v100h312v-98l-209 -502h209v-100h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 251,
    d: "M47 0v700h182v-90h-72v-520h72v-90h-182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 381,
    d: "M5 700h95l276 -700h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 251,
    d: "M22 0v90h72v520h-72v90h182v-700h-182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    d: "M20 390l139 310h78l139 -310h-88l-90 210l-90 -210h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 500,
    d: "M0 -10h500v-80h-500v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 250,
    d: "M44 848h113l68 -111h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM145 222h106l-52 354h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 406,
    d: "M40 0v700h166q85 0 124 -39.5t39 -121.5v-25q0 -107 -71 -140v-2q82 -32 82 -149v-57q0 -81 -42.5 -123.5t-124.5 -42.5h-173zM150 100h63q29 0 43 15.5t14 53.5v61q0 48 -16.5 66.5t-54.5 18.5h-49v-215zM150 415h43q33 0 49.5 17t16.5 57v39q0 72 -56 72h-53v-185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 386,
    d: "M31 168v364q0 85 42 130.5t122 45.5t122 -45.5t42 -130.5v-68h-104v75q0 69 -57 69t-57 -69v-378q0 -68 57 -68t57 68v100h104v-93q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 408,
    d: "M40 0v700h174q164 0 164 -173v-354q0 -173 -164 -173h-174zM150 100h62q56 0 56 68v364q0 68 -56 68h-62v-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 344,
    d: "M40 0v700h291v-100h-181v-211h142v-100h-142v-289h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 390,
    d: "M31 168v364q0 85 42 130.5t122 45.5t122 -45.5t42 -130.5v-68h-104v75q0 69 -57 69t-57 -69v-378q0 -68 57 -68t57 68v129h-50v100h154v-222q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 427,
    d: "M40 0v700h110v-300h125v300h112v-700h-112v300h-125v-300h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 190,
    d: "M40 0v700h110v-700h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 256,
    d: "M10 0v100q12 -1 38 -1q63 0 63 67v534h110v-526q0 -176 -158 -176q-35 0 -53 2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 414,
    d: "M40 0v700h110v-303h2l142 303h110l-153 -312l153 -388h-113l-107 279l-34 -64v-215h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 339,
    d: "M40 0v700h110v-600h181v-100h-291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 541,
    d: "M39 0v700h153l80 -497h2l74 497h153v-700h-104v502h-2l-74 -502h-104l-80 495h-2v-495h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 427,
    d: "M39 0v700h138l111 -419h2v419h98v-700h-113l-135 507h-2v-507h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 377,
    d: "M40 0v700h162q164 0 164 -173v-91q0 -173 -164 -173h-52v-263h-110zM150 363h52q27 0 40.5 15t13.5 51v105q0 36 -13.5 51t-40.5 15h-52v-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -59 -21 -98q6 -15 31 -15h10v-98h-15q-71 0 -95 48q-36 -13 -77 -13q-81 0 -124 46t-43 130zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 402,
    d: "M40 0v700h166q85 0 124 -39.5t39 -121.5v-55q0 -107 -72 -141v-2q73 -31 73 -148v-108q0 -57 12 -85h-112q-10 30 -10 86v110q0 48 -17 68.5t-55 20.5h-38v-285h-110zM150 385h43q33 0 49.5 17t16.5 57v69q0 72 -56 72h-53v-215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 374,
    d: "M23 168v43h104v-50q0 -68 57 -68t57 68q0 39 -20.5 72t-73.5 80q-68 60 -94.5 109t-26.5 110q0 85 41 130.5t121 45.5t121 -45.5t41 -130.5v-22h-104v29q0 69 -55 69t-55 -69q0 -39 20.5 -72t73.5 -80q68 -60 94.5 -109t26.5 -110q0 -85 -42 -130.5t-122 -45.5t-122 45.5 t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 356,
    d: "M8 600v100h340v-100h-115v-600h-110v600h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 402,
    d: "M11 700h111l83 -571h2l83 571h101l-108 -700h-164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 563,
    d: "M15 700h107l58 -552h2l52 552h106l54 -556h2l56 556h96l-78 -700h-146l-39 373h-2l-39 -373h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 430,
    d: "M15 0l123 360l-115 340h114l82 -258h2l84 258h102l-115 -340l123 -360h-116l-89 277h-2l-90 -277h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    d: "M4 700h115l83 -319h2l83 319h105l-139 -468v-232h-110v232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 370,
    d: "M23 0v98l209 502h-199v100h312v-98l-209 -502h209v-100h-322z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 257,
    d: "M11 305v90q31 0 42 12.5t13 47.5l8 134q4 55 33.5 83t77.5 28h56v-90h-16q-27 0 -39 -15.5t-14 -55.5l-5 -100q-4 -73 -65 -89q61 -16 65 -89l5 -100q2 -40 14 -55.5t39 -15.5h16v-90h-56q-48 0 -77.5 28t-33.5 83l-8 134q-2 35 -13 47.5t-42 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 500,
    d: "M210 -65v830h90v-830h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 257,
    d: "M16 0v90h16q27 0 39 15.5t14 55.5l5 100q4 73 65 89q-61 16 -65 89l-5 100q-2 40 -14 55.5t-39 15.5h-16v90h56q48 0 77.5 -28t33.5 -83l8 -134q2 -35 13 -47.5t42 -12.5v-90q-31 0 -42 -12.5t-13 -47.5l-8 -134q-4 -55 -33.5 -83t-77.5 -28h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    d: "M8 332q33 49 60.5 69.5t58.5 20.5q30 0 80 -33q42 -28 63 -28q16 0 28 10.5t38 46.5l52 -54q-32 -47 -59 -66.5t-60 -19.5q-30 0 -80 33q-42 28 -63 28q-16 0 -29 -11.5t-37 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 190,
    d: "M40 0v292l14 253h82l14 -253v-292h-110zM42 594v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    d: "M36 208v284q0 145 117 171v52h90v-51q121 -24 121 -172v-48h-104v55q0 69 -57 69t-57 -69v-298q0 -68 57 -68t57 68v80h104v-73q0 -149 -121 -172v-51h-90v52q-117 24 -117 171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    d: "M30 0v96q40 0 67 30.5t28 83.5h-81v85h67q-6 20 -25 56q-46 93 -46 181q0 85 41 130.5t121 45.5t121 -45.5t41 -130.5v-69h-104v76q0 69 -55 69t-55 -69q0 -86 41 -173q19 -41 26 -71h121v-85h-114q-7 -71 -56 -110h189v-100h-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    d: "M32 227l55 55q-18 30 -18 68t18 67l-55 56l43 43l56 -56q30 19 67 19q35 0 67 -19l56 56l43 -43l-56 -56q19 -32 19 -67q0 -37 -19 -67l56 -56l-43 -43l-56 55q-29 -18 -67 -18t-68 18l-55 -55zM134 350q0 -26 19 -45t45 -19t45 19t19 45t-19 45t-45 19t-45 -19t-19 -45z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    d: "M7 700h115l80 -309h2l80 309h105l-128 -429h83v-55h-91v-45h91v-55h-91v-116h-110v116h-91v55h91v45h-91v55h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 500,
    d: "M210 -65v355h90v-355h-90zM210 410v355h90v-355h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    d: "M35 314q0 82 69 121v2q-69 45 -69 129q0 63 42 102.5t120 39.5t120 -37t42 -99v-36h-104v21q0 27 -14.5 43.5t-40.5 16.5q-55 0 -55 -56q0 -20 16.5 -35.5t59.5 -32.5q75 -30 107 -71t32 -101q0 -82 -70 -122v-2q70 -43 70 -128q0 -63 -42 -102.5t-120 -39.5t-120 37 t-42 99v50h104v-35q0 -27 14.5 -43.5t40.5 -16.5q55 0 55 56q0 20 -16 35t-60 33q-75 31 -107 71.5t-32 100.5zM140 318q0 -47 61 -77q23 4 38.5 25.5t15.5 50.5q0 47 -62 76q-23 -4 -38 -25t-15 -50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 250,
    d: "M1 737v96h96v-96h-96zM153 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 736,
    d: "M20 350q0 155 99.5 256.5t248.5 101.5t248.5 -101.5t99.5 -256.5t-99.5 -256.5t-248.5 -101.5t-248.5 101.5t-99.5 256.5zM92 350q0 -125 78.5 -206.5t197.5 -81.5t197.5 81.5t78.5 206.5t-78.5 206.5t-197.5 81.5t-197.5 -81.5t-78.5 -206.5zM251 252v194q0 124 113 124 t113 -124v-36h-72v42q0 48 -39 48t-39 -48v-204q0 -47 39 -47t39 47v60h72v-56q0 -122 -113 -122t-113 122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 278,
    d: "M30 218v69h212v-69h-212zM30 429v4q0 67 37 95t105 30v46q0 37 -28 37q-34 0 -34 -43v-23h-66v19q0 111 103 111q95 0 95 -111v-261h-59l-3 48h-2q-17 -53 -70 -53q-78 0 -78 101zM100 435q0 -43 36 -43q33 0 36 36v78q-72 -3 -72 -62v-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 355,
    d: "M16 351l62 257h99l-61 -257l61 -273h-99zM178 351l62 257h99l-61 -257l61 -273h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    d: "M25 311v78h346v-215h-78v137h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 270,
    d: "M35 300v100h200v-100h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 736,
    d: "M20 350q0 155 99.5 256.5t248.5 101.5t248.5 -101.5t99.5 -256.5t-99.5 -256.5t-248.5 -101.5t-248.5 101.5t-99.5 256.5zM92 350q0 -125 78.5 -206.5t197.5 -81.5t197.5 81.5t78.5 206.5t-78.5 206.5t-197.5 81.5t-197.5 -81.5t-78.5 -206.5zM258 136v428h116 q113 0 113 -112v-9q0 -75 -52 -98v-2q52 -21 52 -102v-46q0 -39 9 -59h-78q-7 18 -7 60v46q0 34 -12 48t-39 14h-26v-168h-76zM334 374h31q46 0 46 51v18q0 51 -41 51h-36v-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 250,
    d: "M10 741v78h230v-78h-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 228,
    d: "M15 609q0 41 29 70t70 29t70 -29t29 -70t-29 -70t-70 -29t-70 29t-29 70zM65 609q0 -20 14.5 -34.5t34.5 -14.5t34.5 14.5t14.5 34.5t-14.5 34.5t-34.5 14.5t-34.5 -14.5t-14.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    d: "M35 174v78h124v80h-124v78h124v114h78v-114h124v-78h-124v-80h124v-78h-326z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 280,
    d: "M42 351v54q0 38 15 69.5t54 72.5q38 40 53.5 72t15.5 69q0 50 -36 50t-36 -44v-47h-66v43q0 111 104 111t104 -111q0 -45 -19 -85.5t-67 -91.5q-53 -57 -53 -89q0 -8 1 -10h132v-63h-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 280,
    d: "M36 458v36h66v-41q0 -44 36 -44t36 51v34q0 31 -10.5 43.5t-34.5 12.5h-24v63h27q42 0 42 48v25q0 51 -36 51t-36 -44v-28h-66v23q0 112 104 112t104 -112v-11q0 -70 -49 -90v-2q49 -21 49 -92v-35q0 -112 -104 -112t-104 112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 250,
    d: "M27 737l68 111h108l-102 -111h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    d: "M31 -93v593h110v-339q0 -69 57 -69t57 69v339h110v-500h-100v52q-31 -60 -100 -60q-10 0 -24 2v-87h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    d: "M14 436v91q0 173 164 173h178v-765h-80v685h-54v-685h-80v330q-61 0 -94.5 47t-33.5 124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 186,
    d: "M40 297v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 250,
    d: "M26 -79h74v-8q0 -20 22 -20q25 0 25 24q0 26 -36 26h-10v71h48v-53q38 0 56 -10.5t18 -36.5q0 -37 -25 -49t-76 -12q-96 0 -96 58v10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 200,
    d: "M25 690v49q36 0 51.5 14t26.5 42h46v-444h-70v339h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 280,
    d: "M34 218v69h212v-69h-212zM34 439v155q0 53 27.5 82t78.5 29t78.5 -29t27.5 -82v-155q0 -53 -27.5 -82t-78.5 -29t-78.5 29t-27.5 82zM104 435q0 -43 36 -43t36 43v163q0 43 -36 43t-36 -43v-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 355,
    d: "M16 78l61 273l-61 257h99l62 -257l-62 -273h-99zM178 78l61 273l-61 257h99l62 -257l-62 -273h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 627,
    d: "M65 595v49q36 0 51.5 14t26.5 42h46v-444h-70v339h-54zM160 0l276 700h65l-276 -700h-65zM371 80v64l127 300h76v-300h33v-64h-33v-80h-69v80h-134zM434 144h71v164h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 627,
    d: "M65 595v49q36 0 51.5 14t26.5 42h46v-444h-70v339h-54zM130 0l276 700h65l-276 -700h-65zM389 0v54q0 38 15 69.5t54 72.5q38 40 53.5 72t15.5 69q0 50 -36 50t-36 -44v-47h-66v43q0 111 104 111t104 -111q0 -45 -19 -85.5t-67 -91.5q-53 -57 -53 -89q0 -8 1 -10h132v-63 h-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 627,
    d: "M36 363v36h66v-41q0 -44 36 -44t36 51v34q0 31 -10.5 43.5t-34.5 12.5h-24v63h27q42 0 42 48v25q0 51 -36 51t-36 -44v-28h-66v23q0 112 104 112t104 -112v-11q0 -70 -49 -90v-2q49 -21 49 -92v-35q0 -112 -104 -112t-104 112zM170 0l276 700h65l-276 -700h-65zM371 80 v64l127 300h76v-300h33v-64h-33v-80h-69v80h-134zM434 144h71v164h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 360,
    d: "M16 168q0 56 16.5 101.5t57.5 99.5q32 43 44 73t12 64q0 22 -4 39h98q6 -18 6 -43q0 -42 -12.5 -77.5t-44.5 -80.5q-36 -51 -49.5 -91.5t-13.5 -91.5q0 -69 55 -69t55 69v76h104v-69q0 -85 -41 -130.5t-121 -45.5t-121 45.5t-41 130.5zM139 594v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM83 848h113l68 -111h-79zM145 222h106l-52 354h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM145 222h106l-52 354h-2zM145 737l68 111h108l-102 -111h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM65 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94zM145 222h106l-52 354h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM68 770q26 68 85 68q25 0 53 -14q22 -11 37 -11q29 0 43 29l53 -37q-26 -68 -85 -68q-24 0 -53 14q-22 11 -37 11q-29 0 -43 -29zM145 222h106l-52 354h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM79 737v96h96v-96h-96zM145 222h106l-52 354h-2zM231 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM123 814q0 34 23 57t57 23t57 -23t23 -57t-23 -57t-57 -23t-57 23t-23 57zM145 222h106l-52 354h-2zM173 814q0 -13 8.5 -21.5t21.5 -8.5t21.5 8.5t8.5 21.5t-8.5 21.5t-21.5 8.5t-21.5 -8.5t-8.5 -21.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 580,
    d: "M4 0l187 700h361v-100h-190v-195h151v-100h-151v-205h190v-100h-300v127h-111l-32 -127h-105zM166 222h86v337h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 386,
    d: "M31 168v364q0 85 42 130.5t122 45.5t122 -45.5t42 -130.5v-68h-104v75q0 69 -57 69t-57 -69v-378q0 -68 57 -68t57 68v100h104v-93q0 -78 -36.5 -123.5t-105.5 -51.5v-32q38 0 56 -10.5t18 -36.5q0 -37 -25 -49t-76 -12q-96 0 -96 58v10h74v-8q0 -20 22 -20q25 0 25 24 q0 26 -36 26h-10v51q-138 14 -138 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300zM68 848h113l68 -111h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300zM131 737l68 111h108l-102 -111h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300zM50 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300zM65 737v96h96v-96h-96zM217 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 190,
    d: "M-25 848h113l68 -111h-79zM40 0v700h110v-700h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 190,
    d: "M37 737l68 111h108l-102 -111h-74zM40 0v700h110v-700h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 190,
    d: "M-43 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94zM40 0v700h110v-700h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 190,
    d: "M-29 737v96h96v-96h-96zM40 0v700h110v-700h-110zM123 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 408,
    d: "M4 305v90h36v305h174q164 0 164 -173v-354q0 -173 -164 -173h-174v305h-36zM150 100h62q56 0 56 68v364q0 68 -56 68h-62v-205h68v-90h-68v-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 427,
    d: "M39 0v700h138l111 -419h2v419h98v-700h-113l-135 507h-2v-507h-99zM78 770q26 68 85 68q25 0 53 -14q22 -11 37 -11q29 0 43 29l53 -37q-26 -68 -85 -68q-24 0 -53 14q-22 11 -37 11q-29 0 -43 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM77 848h113l68 -111h-79zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM140 737l68 111h108l-102 -111h-74zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM59 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM63 770q26 68 85 68q25 0 53 -14q22 -11 37 -11q29 0 43 29l53 -37q-26 -68 -85 -68q-24 0 -53 14q-22 11 -37 11q-29 0 -43 -29zM141 161q0 -69 57 -69t57 69v378 q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM74 737v96h96v-96h-96zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378zM226 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    d: "M38 244l106 106l-105 105l53 53l106 -105l106 106l53 -53l-106 -106l106 -106l-53 -53l-106 106l-107 -106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    d: "M31 168v364q0 84 43 130t124 46q60 0 100 -26l20 55l37 -13l-26 -71q36 -43 36 -121v-364q0 -84 -43 -130t-124 -46q-62 0 -100 25l-20 -54l-37 13l25 70q-35 46 -35 122zM141 257h2l110 303q-7 48 -55 48q-57 0 -57 -69v-282zM142 140q8 -48 56 -48q57 0 57 69v282h-2z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5zM79 848h113l68 -111h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5zM142 737l68 111h108l-102 -111h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5zM62 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5zM77 737v96h96v-96h-96zM229 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    d: "M4 700h115l83 -319h2l83 319h105l-139 -468v-232h-110v232zM144 737l68 111h108l-102 -111h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 377,
    d: "M40 0v700h110v-80h52q164 0 164 -173v-91q0 -173 -164 -173h-52v-183h-110zM150 283h52q27 0 40.5 15t13.5 51v105q0 36 -13.5 51t-40.5 15h-52v-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 748,
    d: "M23 168v43h104v-50q0 -68 57 -68t57 68q0 39 -20.5 72t-73.5 80q-68 60 -94.5 109t-26.5 110q0 85 41 130.5t121 45.5t121 -45.5t41 -130.5v-22h-104v29q0 69 -55 69t-55 -69q0 -39 20.5 -72t73.5 -80q68 -60 94.5 -109t26.5 -110q0 -85 -42 -130.5t-122 -45.5t-122 45.5 t-42 130.5zM397 168v43h104v-50q0 -68 57 -68t57 68q0 39 -20.5 72t-73.5 80q-68 60 -94.5 109t-26.5 110q0 85 41 130.5t121 45.5t121 -45.5t41 -130.5v-22h-104v29q0 69 -55 69t-55 -69q0 -39 20.5 -72t73.5 -80q68 -60 94.5 -109t26.5 -110q0 -85 -42 -130.5t-122 -45.5 t-122 45.5t-42 130.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM83 848h113l68 -111h-79zM145 222h106l-52 354h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM145 222h106l-52 354h-2zM145 737l68 111h108l-102 -111h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM65 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94zM145 222h106l-52 354h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM68 770q26 68 85 68q25 0 53 -14q22 -11 37 -11q29 0 43 29l53 -37q-26 -68 -85 -68q-24 0 -53 14q-22 11 -37 11q-29 0 -43 -29zM145 222h106l-52 354h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM79 737v96h96v-96h-96zM145 222h106l-52 354h-2zM231 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 407,
    d: "M11 0l112 700h161l112 -700h-111l-19 127h-135l-19 -127h-101zM123 814q0 34 23 57t57 23t57 -23t23 -57t-23 -57t-57 -23t-57 23t-23 57zM145 222h106l-52 354h-2zM173 814q0 -13 8.5 -21.5t21.5 -8.5t21.5 8.5t8.5 21.5t-8.5 21.5t-21.5 8.5t-21.5 -8.5t-8.5 -21.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 580,
    d: "M4 0l187 700h361v-100h-190v-195h151v-100h-151v-205h190v-100h-300v127h-111l-32 -127h-105zM166 222h86v337h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 386,
    d: "M31 168v364q0 85 42 130.5t122 45.5t122 -45.5t42 -130.5v-68h-104v75q0 69 -57 69t-57 -69v-378q0 -68 57 -68t57 68v100h104v-93q0 -78 -36.5 -123.5t-105.5 -51.5v-32q38 0 56 -10.5t18 -36.5q0 -37 -25 -49t-76 -12q-96 0 -96 58v10h74v-8q0 -20 22 -20q25 0 25 24 q0 26 -36 26h-10v51q-138 14 -138 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300zM68 848h113l68 -111h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300zM131 737l68 111h108l-102 -111h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300zM50 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 368,
    d: "M40 0v700h300v-100h-190v-195h151v-100h-151v-205h190v-100h-300zM65 737v96h96v-96h-96zM217 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 190,
    d: "M-25 848h113l68 -111h-79zM40 0v700h110v-700h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 190,
    d: "M37 737l68 111h108l-102 -111h-74zM40 0v700h110v-700h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 190,
    d: "M-43 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94zM40 0v700h110v-700h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 190,
    d: "M-29 737v96h96v-96h-96zM40 0v700h110v-700h-110zM123 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 408,
    d: "M4 305v90h36v305h174q164 0 164 -173v-354q0 -173 -164 -173h-174v305h-36zM150 100h62q56 0 56 68v364q0 68 -56 68h-62v-205h68v-90h-68v-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 427,
    d: "M39 0v700h138l111 -419h2v419h98v-700h-113l-135 507h-2v-507h-99zM78 770q26 68 85 68q25 0 53 -14q22 -11 37 -11q29 0 43 29l53 -37q-26 -68 -85 -68q-24 0 -53 14q-22 11 -37 11q-29 0 -43 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM77 848h113l68 -111h-79zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM140 737l68 111h108l-102 -111h-74zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM59 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM63 770q26 68 85 68q25 0 53 -14q22 -11 37 -11q29 0 43 29l53 -37q-26 -68 -85 -68q-24 0 -53 14q-22 11 -37 11q-29 0 -43 -29zM141 161q0 -69 57 -69t57 69v378 q0 69 -57 69t-57 -69v-378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    d: "M31 168v364q0 84 43 130t124 46t124 -46t43 -130v-364q0 -84 -43 -130t-124 -46t-124 46t-43 130zM74 737v96h96v-96h-96zM141 161q0 -69 57 -69t57 69v378q0 69 -57 69t-57 -69v-378zM226 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    d: "M25 311v78h346v-78h-346zM145 144v106h106v-106h-106zM145 449v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    d: "M31 168v364q0 84 43 130t124 46q60 0 100 -26l20 55l37 -13l-26 -71q36 -43 36 -121v-364q0 -84 -43 -130t-124 -46q-62 0 -100 25l-20 -54l-37 13l25 70q-35 46 -35 122zM141 257h2l110 303q-7 48 -55 48q-57 0 -57 -69v-282zM142 140q8 -48 56 -48q57 0 57 69v282h-2z "
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5zM79 848h113l68 -111h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5zM142 737l68 111h108l-102 -111h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5zM62 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 398,
    d: "M35 167v533h110v-540q0 -68 57 -68t57 68v540h104v-533q0 -85 -42 -130.5t-122 -45.5t-122 45.5t-42 130.5zM77 737v96h96v-96h-96zM229 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    d: "M4 700h115l83 -319h2l83 319h105l-139 -468v-232h-110v232zM144 737l68 111h108l-102 -111h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 377,
    d: "M40 0v700h110v-80h52q164 0 164 -173v-91q0 -173 -164 -173h-52v-183h-110zM150 283h52q27 0 40.5 15t13.5 51v105q0 36 -13.5 51t-40.5 15h-52v-237z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    d: "M4 700h115l83 -319h2l83 319h105l-139 -468v-232h-110v232zM78 737v96h96v-96h-96zM230 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 586,
    d: "M30 173v354q0 173 164 173h364v-100h-190v-195h151v-100h-151v-205h190v-100h-364q-164 0 -164 173zM140 168q0 -68 56 -68h62v500h-62q-56 0 -56 -68v-364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 586,
    d: "M30 173v354q0 173 164 173h364v-100h-190v-195h151v-100h-151v-205h190v-100h-364q-164 0 -164 173zM140 168q0 -68 56 -68h62v500h-62q-56 0 -56 -68v-364z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    d: "M4 700h115l83 -319h2l83 319h105l-139 -468v-232h-110v232zM78 737v96h96v-96h-96zM230 737v96h96v-96h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 250,
    d: "M-13 737l89 111h99l89 -111h-94l-45 55l-44 -55h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 250,
    d: "M-10 770q26 68 85 68q25 0 53 -14q22 -11 37 -11q29 0 43 29l53 -37q-26 -68 -85 -68q-24 0 -53 14q-22 11 -37 11q-29 0 -43 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 447
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 894
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 447
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 894
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 298
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 223
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 149
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 149
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 111
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 178
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 49
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 270,
    d: "M35 300v100h200v-100h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 270,
    d: "M35 300v100h200v-100h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 270,
    d: "M35 300v100h200v-100h-200z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M0 305v90h500v-90h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M0 305v90h1000v-90h-1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 186,
    d: "M40 494v95l48 111h45l-29 -100h42v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 186,
    d: "M40 594v106h106v-95l-48 -111h-45l29 100h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 186,
    d: "M40 0v106h106v-95l-48 -111h-45l29 100h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 332,
    d: "M40 494v95l48 111h45l-29 -100h42v-106h-106zM186 494v95l48 111h45l-29 -100h42v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 332,
    d: "M40 594v106h106v-95l-48 -111h-45l29 100h-42zM186 594v106h106v-95l-48 -111h-45l29 100h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 332,
    d: "M40 0v106h106v-95l-48 -111h-45l29 100h-42zM186 0v106h106v-95l-48 -111h-45l29 100h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    d: "M59 350q0 58 40.5 98.5t98.5 40.5t98.5 -40.5t40.5 -98.5t-40.5 -98.5t-98.5 -40.5t-98.5 40.5t-40.5 98.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 478,
    d: "M40 0v106h106v-106h-106zM186 0v106h106v-106h-106zM332 0v106h106v-106h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 178
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 196,
    d: "M16 351l60 266h104l-59 -266l59 -282h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 196,
    d: "M16 69l59 282l-59 266h104l60 -266l-60 -282h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 223
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    d: "M19 270v55h28v55h-28v55h28v97q0 85 40.5 130.5t120.5 45.5t120.5 -45.5t40.5 -130.5v-51h-104v58q0 69 -54 69t-54 -69v-104h154v-55h-154v-55h154v-55h-154v-109q0 -68 54 -68t54 68v63h104v-56q0 -85 -40.5 -130.5t-120.5 -45.5t-120.5 45.5t-40.5 130.5v102h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 586,
    d: "M10 636v64h216v-64h-73v-292h-70v292h-73zM268 344v356h97l51 -250h2l46 250h97v-356h-66v253h-2l-45 -253h-66l-51 251h-2v-251h-61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 700,
    d: "M0 0v700h700v-700h-700z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0178",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xFF",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xFD",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xDD",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "y",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "w",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "v",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "t",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "Y",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "W",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "V",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "T",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFF",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xFA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xDA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "w",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "u",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "s",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "U",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xFF",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xFD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xFC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xFB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xFA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xF9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "w",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "u",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "s",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "U",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\xFF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\xFD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "t",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "T",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0178",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xFF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xFD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\xDD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "t",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "Y",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "T",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u201E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u201A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u201D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u201C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u2018",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "}",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "]",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ")",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0153",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0152",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "q",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "Q",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201C",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2018",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "}",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "]",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: ")",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0178",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xFF",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xFD",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xDD",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "y",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Y",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "v",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u201E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u201D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u201C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u201A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u2018",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u2026",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "}",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "]",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ";",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ":",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: ")",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "}",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "j",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "]",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ")",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u2026",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u201A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "}",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "]",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ".",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: ")",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u201D",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u201C",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2019",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2018",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0152",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xC7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xAD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "s",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "g",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "S",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "-",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0152",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "}",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "]",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "Q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ":",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: ")",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0178",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xFF",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xFD",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xDD",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "y",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "w",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "v",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "t",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "Y",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "W",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "V",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "T",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u201A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "v",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "X",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "V",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u201D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u201C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u2018",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2026",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "}",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "]",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ".",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ",",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ")",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0153",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "\u0152",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "q",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "Q",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\u201D",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\u201C",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\u2018",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "}",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "]",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: ")",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0178",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\xFF",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\xFD",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\xDD",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "y",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "Y",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "v",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "V",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u201E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u201D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u201C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u201A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\u2018",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u2026",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "}",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "]",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: ";",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: ":",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: ")",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "u",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u2026",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE7",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xE0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD8",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD6",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD4",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC7",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xC0",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xAD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "}",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "o",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "j",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "g",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "c",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "a",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "]",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "O",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "C",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "-",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u2026",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u201A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "}",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "]",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ".",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: ")",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u201D",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u201C",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u2019",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u2018",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0152",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xD2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xC7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xAD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "s",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "g",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "S",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "Q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "O",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "G",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "-",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0152",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "}",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "]",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "Q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ":",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: ")",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0178",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xFF",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xFD",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xDD",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "y",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "w",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "v",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "t",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "Y",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "W",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "V",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "T",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAD",
    u2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0178",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xFF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xFD",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xDD",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "t",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "Y",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "T",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u201D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u201C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u2018",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0152",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "}",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "]",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "Q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ":",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: ")",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0178",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xFF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xFD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xE5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xE4",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xE3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xE2",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xE1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xE0",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xDD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC4",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC2",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xC0",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "y",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "j",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "a",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "Z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "Y",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "A",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u201E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u201D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u201C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u201A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\u2018",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u201D",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u201C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u2018",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u0153",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "\u0152",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "v",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "V",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "Q",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u201D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u201C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u2018",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "x",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "v",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "V",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF9",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF9",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF9",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF9",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF9",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFA",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFA",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFA",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFA",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFA",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFB",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFB",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFB",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFB",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFB",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFC",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFC",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFC",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFC",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFC",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "\u0152",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "}",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "]",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: "Q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ":",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFD",
    u2: ")",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\u0178",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xFF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xFD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xE5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xE4",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xE3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xE2",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xE1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xE0",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xDD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xC6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xC5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xC4",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xC3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xC2",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xC1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xC0",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "y",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "j",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "a",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "Z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "Y",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "A",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "\u0152",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "}",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "]",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: "Q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ":",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFF",
    u2: ")",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u2026",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u201E",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u201A",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0153",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0152",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "}",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "]",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "Q",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ";",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ":",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ".",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ",",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: ")",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xDF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "z",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "x",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "s",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "j",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "a",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "Z",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "X",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "x",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "X",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xFF",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xFD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xFC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xFB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xFA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xF9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xDA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "w",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "u",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "s",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "U",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xDF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "z",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "x",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "s",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "j",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "a",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Z",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "X",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xDF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "z",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "x",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "s",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "j",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "a",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "Z",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "X",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "J",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xFF",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xFD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xFC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xFB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xFA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xF9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xDA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "w",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "u",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "s",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "U",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u0152",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xFF",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xFD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xFC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xFB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xFA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xF9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xDF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xDC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xDB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xDA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xD9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "w",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "v",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "u",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "s",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "W",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "V",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "U",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "T",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "C,Ccedilla",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "G",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "T",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "W",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "Y,Yacute,Ydieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "quoteright",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "hyphen,uni00AD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "c,ccedilla",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "g",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "w",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    g2: "y,yacute,ydieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "quoteright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "W",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "Y,Yacute,Ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "quoteright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "w",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "y,yacute,ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "Y,Yacute,Ydieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "quoteright",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "y,yacute,ydieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla",
    g2: "Y,Yacute,Ydieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla",
    g2: "quoteright",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla",
    g2: "y,yacute,ydieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "Y,Yacute,Ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "quoteright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "y,yacute,ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "AE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,eth",
    g2: "Y,Yacute,Ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,eth",
    g2: "quoteright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,eth",
    g2: "y,yacute,ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,eth",
    g2: "AE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,eth",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,eth",
    g2: "ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "Z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "AE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "ae",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "J",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "Z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "j",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y,Yacute,Ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "quoteright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "y,yacute,ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "AE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "Y,Yacute,Ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "quoteright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "y,yacute,ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "AE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g",
    g2: "ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "AE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J",
    g2: "ae",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j",
    g2: "AE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j",
    g2: "ae",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C,Ccedilla",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "G",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,ccedilla",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "g",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "s,germandbls",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "C,Ccedilla",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "G",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,ccedilla",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "g",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "s,germandbls",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "quoteright",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "hyphen,uni00AD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "t",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "w",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "y,yacute,ydieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "J",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "j",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "T",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "W",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "Y,Yacute,Ydieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "quoteright",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "hyphen,uni00AD",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "t",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "w",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "y,yacute,ydieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "J",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l",
    g2: "j",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "quoteright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "y,yacute,ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "AE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "quoteright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "y,yacute,ydieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "AE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ydieresis",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "y,yacute,ydieresis",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "j",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p",
    g2: "Y,Yacute,Ydieresis",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p",
    g2: "y,yacute,ydieresis",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p",
    g2: "AE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p",
    g2: "ae",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p",
    g2: "J",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p",
    g2: "j",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "Y,Yacute,Ydieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "y,yacute,ydieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "Y,Yacute,Ydieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "y,yacute,ydieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "Y,Yacute,Ydieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "quoteright",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "y,yacute,ydieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "AE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls",
    g2: "Y,Yacute,Ydieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls",
    g2: "quoteright",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls",
    g2: "y,yacute,ydieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls",
    g2: "AE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,germandbls",
    g2: "ae",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "hyphen,uni00AD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "ae",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "J",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "j",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "hyphen,uni00AD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "AE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "ae",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "J",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "j",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "AE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "ae",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis",
    g2: "AE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis",
    g2: "ae",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "hyphen,uni00AD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "AE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "ae",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "j",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "hyphen,uni00AD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "AE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "ae",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "J",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "j",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "C,Ccedilla",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "G",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "hyphen,uni00AD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,ccedilla",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "g",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "ae",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "J",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "j",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "S",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "s,germandbls",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "C,Ccedilla",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "G",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "hyphen,uni00AD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,ccedilla",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "g",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "AE",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "ae",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "J",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "j",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "S",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "s,germandbls",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "hyphen,uni00AD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "hyphen,uni00AD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "T",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "W",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "Y,Yacute,Ydieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "t",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "w",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "y,yacute,ydieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "Z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD",
    g2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "C,Ccedilla",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "c,ccedilla",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "J",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "Z",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "j",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "z",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright",
    g2: "s,germandbls",
    k: 5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBebasNeueWebfont);
export default __webpack_public_path__ + "static/media/BebasNeue-webfont.c8368a383fd40d7fe7d4e82e81f6392b.svg";
export { ForwardRef as ReactComponent };